function compareTwoEntries(value1: string, value2: string, flags = 'i') {
  const regExp = new RegExp(value1, flags);

  return regExp.test(value2);
}

export { compareTwoEntries };
